import { FC, ReactNode, useMemo } from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { buttonChangeStop } from '../styles'

interface DropdownActionProps {
  options: { id: string; name: string }[]
  title: string
  iconStart?: ReactNode
  iconEnd?: ReactNode
  handleOnClick: (id: string) => void
  disabled: boolean
}

const DropdownAction: FC<DropdownActionProps> = ({ options, title, iconStart, iconEnd, handleOnClick, disabled }) => {
  const menu = useMemo(() => {
    return (
      <Menu>
        {options.map((option) => (
          <Menu.Item key={option.id} onClick={() => handleOnClick(option.id)}>
            {option.name}
          </Menu.Item>
        ))}
      </Menu>
    )
  }, [options])
  return (
    <Dropdown overlay={menu} disabled={disabled}>
      <Button style={buttonChangeStop}>
        {iconStart && iconStart}
        {title}
        {iconEnd && iconEnd}
      </Button>
    </Dropdown>
  )
}

export default DropdownAction
